import { CmsApiFourArticlesHighlightBlockData } from 'modules/cms/api/types/blocks/CmsApiFourArticlesHighlightBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

import { CmsAmpFourArticlesHighlightBlock } from './CmsAmpFourArticlesHighlightBlock';
import { CmsFourArticlesHighlightBlock } from './CmsFourArticlesHighlightBlock';

export const CmsFourArticlesHighlightBlockMapping: CmsBlockMapping<CmsApiFourArticlesHighlightBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: CmsFourArticlesHighlightBlock,
    AmpComponent: CmsAmpFourArticlesHighlightBlock,
  };
